/** Data barrel: board geometry/zones + tunable constants. */
export * from "./board";
export * from "./constants";

export const AUGMENTED_WAR_VERSION = "0.1.0";
